import {
  FilterMode,
  PublisherCreateMutationVariables,
  Publisher_OrderBy,
  Publisher,
  SortOrder,
  Publisher_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const publisherService = {
  createOne: buildCreateOne(
    (publisherCreateVariables: PublisherCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.publisherCreate(publisherCreateVariables);
        return result.publisherCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.publisherOne({ id });
    return result.publisherOne as Publisher;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Publisher_OrderBy[] | null = null,
    filter: Publisher_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Publisher_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            pseudonym: { contains: searchValue, mode: FilterMode.Insensitive },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.publisherListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ name: SortOrder.Asc }, { pseudonym: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.publisherListWithOffset
    ) as Publisher[];
    return { list, orderBy };
  },
};
